import React, { Component } from "react";
import SSOContainer from "../shared/containers/SSOContainer";
import MFASSOContainer from "../shared/containers/MFASSOContainer";
import { getContentByVariationType } from "../../content/ContentDoneSimply";
import Store from "../../content/Store";
import MembershipNumberInput from "./MembershipNumberInput";
import MemberNameInput from "./MemberNameInput";
import MemberDobInput from "./MemberDobInput";
import Button from "../shared/buttons/Button";
import OnBoardMemberService from "../../services/OnBoardMemberService";
import { Paths } from "../../constants/UrlConstants";
import mfaStyles from "../../assets/css/modules/containers/MFASSOContainer.css";
import {
  OnboardingResponseStatus,
  DateTimeFormats,
  Layouts
} from "../../constants/Constants";
import { withRouter } from "react-router-dom";
import { validateMemberDetails } from "./ValidateMemberDetails";
import MemberDetailsValidationMessages from "./MemberDetailsValidationMessages";
import Scroll from "react-scroll";
import { setIsUserOnboarding } from "./onboardingActions";
import { connect } from "react-redux";
import moment from "moment";
import styles from "../../assets/css/modules/onboarding/member-details.css";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";
import { trackException } from "../../logging/AppInsightsLogger";
import { Urls } from "../../constants/UrlConstants";
import { ButtonConfig } from "../../constants/Constants";

export const defaultDate = { day: 1, month: 0, year: 1800 };
export const elementNameToScrollTo = "errorsScrollToElement";

export const mapStateToMemberDetails = ({ layoutReducer = {} }) => {
  return {
    content: getContentByVariationType(
      layoutReducer.layout === Layouts.HOL
        ? Store.MemberDetails.contentTypes.HOL
        : Store.MemberDetails.contentTypes.Any,
      Store.MemberDetails
    )
  };
};

const parseDateOfBirth = (dateOfBirth) => {
  return new Date(dateOfBirth.year, dateOfBirth.month, dateOfBirth.day);
};

export class MemberDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        dateOfBirth: { ...defaultDate },
        membershipNumber: "",
        firstName: "",
        surname: ""
      },
      validationMessages: []
    };
  }

  componentDidMount = () => {
    this.props.setIsUserOnboarding(true);
  };

  onChangeHandler = (event) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [event.target.name]: event.target.value
      }
    });
  };

  onChangeHandlerForDateOfBirth = (date, fieldName) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [fieldName]: date
      }
    });
  };

  onSubmit = async (event) => {
    event.preventDefault();

    this.setState({
      validationMessages: []
    });

    var dataToValidate = this.prepareDatesForValidation();
    var frontEndValidationStatuses = validateMemberDetails(dataToValidate);

    if (
      Array.isArray(frontEndValidationStatuses) &&
      frontEndValidationStatuses.length === 0
    ) {
      try {
        dataToValidate = this.prepareMemberDetailsForRequest(dataToValidate);
        await OnBoardMemberService(dataToValidate);
        this.props.history.push(Paths.HomeContactPreference);
      } catch (error) {
        this.handleSpecialErrorStatuses(error);
      }
    } else {
      this.showValidationMessages(frontEndValidationStatuses);
    }
  };

  handleSpecialErrorStatuses = (error) => {
    const validationErrors = this.props.content.validationErrors;

    switch (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.Status
    ) {
      case OnboardingResponseStatus.RestrictedGroup:
        this.props.history.push(Paths.RestrictedGroup);
        break;
      case OnboardingResponseStatus.RestrictedPolicy:
        this.props.history.push(Paths.RestrictedPolicy);
        break;
      case OnboardingResponseStatus.LockedPolicy:
        this.props.history.push(Paths.PolicyLocked);
        break;
      case OnboardingResponseStatus.NoAccessToPolicy:
        this.props.history.push(Paths.OnlineAccessUnavailable);
        break;
      case OnboardingResponseStatus.InvalidMemberDetails:
        this.showValidationMessages([validationErrors.InvalidMemberDetails]);
        break;
      case OnboardingResponseStatus.UserExistsButIsNotReset:
        this.showValidationMessages([
          validationErrors.MemberAlreadyRegistered(error.response.data.Detail)
        ]);
        break;
      case OnboardingResponseStatus.UserExistinSF:
        this.showValidationMessages([
          validationErrors.MemberExistInSF(error.response.data.Detail)
        ]);
        break;
      case OnboardingResponseStatus.policyNotLinkedToSameAccountinSF:
        this.showValidationMessages([validationErrors.policyNotLinkedToSameAccountinSF]);
        break;        
      case OnboardingResponseStatus.OnboardingFailed:
        this.showValidationMessages([validationErrors.OnboardingFailed]);
        break;        
      case OnboardingResponseStatus.OnboardingFailedHybridDataMismatch:
        this.showValidationMessages([validationErrors.OnboardingFailedHybridDataMismatch]);
        break;
      case OnboardingResponseStatus.UnabletoMatchbySystemRecord:
        this.showValidationMessages([validationErrors.UnabletoMatchbySystemRecord]);
        break;
      default: {
        trackException(
          redirectToErrorPageMessage,
          `Something went wrong while onboarding member. MembershipNumber: ${
            this.state.formData && this.state.formData.membershipNumber
          }`
        );
        this.props.history.push(Paths.Error);
      }
    }
  };

  showValidationMessages(messages) {
    this.setState({
      validationMessages: messages
    });
    Scroll.scroller.scrollTo(elementNameToScrollTo, {
      duration: 750,
      smooth: "true"
    });
  }

  prepareDatesForValidation = () => {
    return {
      ...this.state.formData,
      dateOfBirth: parseDateOfBirth(this.state.formData.dateOfBirth)
    };
  };

  prepareMemberDetailsForRequest = (formData) => {
    return {
      ...this.state.formData,
      membershipNumber: formData.membershipNumber.trim(),
      firstName: formData.firstName.trim(),
      surname: formData.surname.trim(),
      dateOfBirth: moment(formData.dateOfBirth).format(DateTimeFormats.apiMask)
    };
  };

  render() {
    const { dateOfBirth } = {
      ...this.state.formData
    };
    return (
      window?.axa?.features?.MFAFeature === "true"?
      (<MFASSOContainer mfa={true}>
        <form name={elementNameToScrollTo}>
          <h1 className={`axa-headline ${styles.titleMFA}`} data-title>
            {this.props.content.title}
          </h1>
          <p data-description>{this.props.content.description}</p>
          <MemberDetailsValidationMessages
            validationMessages={this.state.validationMessages}
            multiMessageHeading={
              this.props.content.validationErrors.CorrectErrors
            }
            mfa={true}
          ></MemberDetailsValidationMessages>
          <MembershipNumberInput onChange={this.onChangeHandler} mfa={true}/>
          <MemberNameInput
            onChange={this.onChangeHandler}
            firstNameContent={this.props.content.firstName}
            surnameContent={this.props.content.surname}
            mfa={true}
          />
          <MemberDobInput
            date={dateOfBirth}
            onChange={this.onChangeHandlerForDateOfBirth}
            label={this.props.content.dateOfBirth.label}
            ariaLabel={this.props.content.dateOfBirth.ariaLabel}
            mfa={true}
          />
          <button
              label={this.props.content.submit.label}
              className={mfaStyles.buttonStart}
              onClick={(e) => this.onSubmit(e)}
            type="submit"
            >{this.props.content.submit.label}</button>
            <div className={styles.FAQN}>
           <a id={ButtonConfig.OnboardingNeedHelp} href={Urls.FaqLink} target="_blank" rel="noopener noreferrer">{this.props.content.help.label}</a>
           </div>
        </form>
      </MFASSOContainer>):
      (<SSOContainer>
        <form name={elementNameToScrollTo}>
          <h1 className={`axa-headline ${styles.title}`} data-title>
            {this.props.content.title}
          </h1>
          <p data-description>{this.props.content.description}</p>
          <MemberDetailsValidationMessages
            validationMessages={this.state.validationMessages}
            multiMessageHeading={
              this.props.content.validationErrors.CorrectErrors
            }
          ></MemberDetailsValidationMessages>
          <MembershipNumberInput onChange={this.onChangeHandler} />
          <MemberNameInput
            onChange={this.onChangeHandler}
            firstNameContent={this.props.content.firstName}
            surnameContent={this.props.content.surname}
          />
          <MemberDobInput
            date={dateOfBirth}
            onChange={this.onChangeHandlerForDateOfBirth}
            label={this.props.content.dateOfBirth.label}
            ariaLabel={this.props.content.dateOfBirth.ariaLabel}
          />
          <Button
            label={this.props.content.submit.label}
            onClick={(e) => this.onSubmit(e)}
            type="submit"
          ></Button>
            <div className="FAQN">
            
           <a id={ButtonConfig.OnboardingNeedHelp} href={Urls.FaqLink} target="_blank" rel="noopener noreferrer">{this.props.content.help.label}</a>
           </div>
        </form>
      </SSOContainer>)
  );
  }
}

export default withRouter(
  connect(mapStateToMemberDetails, { setIsUserOnboarding })(MemberDetails)
);
